import builder from '../builder';
import LockShield from '../../streamline-icons/bold/lock-shield.svg';

export default builder('IconLockShieldBold', LockShield);
